import React from 'react';
// import PropTypes from 'prop-types';
import SidebarHeader from '../SidebarHeader';
import HelpContent from './HelpContent';
import HelpFooter from './HelpFooter';
import { connect } from 'dva';
import X from '../../../assets/svg/Feather/X';

function HelpSidebar(props) {
  const closeSidebar = (e) => {
    e.preventDefault();
    props.dispatch({
      type: 'app/clearSidebarHistory'
    });
    props.dispatch({
      type: 'app/setShowSidebar',
      payload: false
    });
  };

  return (
    <>
      <SidebarHeader text="My Content" icon={X} onClickIcon={closeSidebar}/>
      <HelpContent />
      <HelpFooter />
    </>
  );
}

HelpSidebar.propTypes = {

};

export default connect(() => {
  return {};
})(HelpSidebar);